import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { API } from '../../../services/api/api';
import { ModalService } from '../../../services/gui/modal/modal.service';
import { ToasterService, ToastType } from '../../../services/toaster/toaster.service';
import { ErrorService } from '../../../services/error.service';
import { TranslateService } from '@ngx-translate/core';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const CONNECT_CLIENT_PATH = 'connectClient';

@Component({
  selector: 'page-client-invitations',
  templateUrl: './client-invitations.component.html',
  styleUrls: ['./client-invitations.component.scss'],
  standalone: false,
})
export class ClientInvitationsComponent implements OnInit {
  private api = inject(API);
  private errorService = inject(ErrorService);
  private translate = inject(TranslateService);
  private toastService = inject(ToasterService);
  private modalService = inject(ModalService);
  private destroyRef = inject(DestroyRef);

  public invitationCode: string = null;
  public loadingInviteCode: boolean = true;

  ngOnInit(): void {
    this.loadingInviteCode = true;
    this.api
      .shared_ClientConnection_getInvitationCode()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loadingInviteCode = false;
        })
      )
      .subscribe({
        next: code => {
          this.invitationCode = code;
        },
        error: () => {},
      });
  }

  public generateNew(): void {
    this.modalService
      .confirm({
        title: this.translate.instant('lang.clientManagement.connection.code.generateNew.headline'),
        message: this.translate.instant('lang.clientManagement.connection.code.generateNew.infoText'),
        yes: this.translate.instant('lang.clientManagement.connection.code.generateNew.generate'),
        no: this.translate.instant('lang.globals.cancel'),
      })
      .then(confirmed => {
        if (confirmed) {
          this.loadingInviteCode = true;
          this.api
            .shared_ClientConnection_generateInvitationCode()
            .pipe(
              takeUntilDestroyed(this.destroyRef),
              take(1),
              finalize(() => {
                this.loadingInviteCode = false;
              })
            )
            .subscribe({
              next: (code: string) => {
                this.invitationCode = code;
                this.toastService.toast(
                  ToastType.SUCCESS,
                  this.translate.instant('lang.clientManagement.connection.code.generateNew.generated')
                );
              },
              error: error => {
                this.errorService.errorHandler(error);
              },
            });
        }
      });
  }

  public copy(): void {
    navigator.clipboard
      .writeText(this.invitationLink)
      .then(() => {
        this.toastService.toast(ToastType.SUCCESS, this.translate.instant('lang.clientManagement.connection.code.copied'));
      })
      .catch(() => {
        this.toastService.toast(ToastType.DANGER, this.translate.instant('lang.clientManagement.connection.code.couldNotCopy'));
      });
  }

  public get invitationLink(): string {
    return document.location.protocol + '//' + document.location.host + '/' + CONNECT_CLIENT_PATH + '?token=' + this.invitationCode;
  }
}
